import { HelperText } from "@common/components/HelperText/HelperText";
import { SearchInput } from "@common/components/SearchInput/SearchInput";
import { vars } from "@common/styles";
import styled from "styled-components";

export const MembersSearch = styled(SearchInput)`
  height: 4rem;
  width: auto;
  background-color: ${vars.colors.black};
`;

export const Helper = styled(HelperText)`
  margin-top: 1.2rem;
`;
